import { NamedModel } from 'api/Exec/types';
import { modelsUrl } from 'app/consts/urls';
import { pluralize } from 'app/helpers/pluralize';

import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Space, Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React from 'react';

const useColumns = (
  onDetailsClick: (namedModel: NamedModel) => void,
  onHistoryClick: (namedModel: NamedModel) => void,
  editNamedModel: (namedModel: NamedModel) => void,
) => {
  const columns: ColumnsType<NamedModel> = [
    {
      title: 'Name',
      dataIndex: 'modelName',
      key: 'modelName',
    },
    {
      title: 'API name',
      dataIndex: 'modelApiName',
      key: 'modelApiName',
    },
    {
      title: 'Image tag',
      key: 'modelImageTag',
      render: (_, { modelImageTag, modelId }) => {
        return <Typography.Link href={`${modelsUrl}/?model=${modelId}`} target="_blank">{modelImageTag}</Typography.Link>;
      },
    },
    {
      title: 'Sandbox',
      key: 'sandbox',
      align: 'center',
      render: (_, { isSandbox }) => {
        return isSandbox ? <CheckCircleFilled style={{ color: '#00B96B' }} /> : <CloseCircleFilled style={{ color: '#D9D9D9' }} />;
      },
    },
    {
      title: 'CV',
      key: 'clinicalValidated',
      align: 'center',
      render: (_, { clinicalValidated }) => {
        return clinicalValidated ? <CheckCircleFilled style={{ color: '#00B96B' }} /> : <CloseCircleFilled style={{ color: '#D9D9D9' }} />;
      },
    },
    {
      title: 'Usage',
      key: 'usage',
      render: (_, { usedInOrgs }) => pluralize(usedInOrgs, 'org'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, { enabled, id }) => {
        return (
          <Tag color={enabled ? 'purple' : 'error'} key={id}>
            {enabled ? 'Enabled' : 'Disabled'}
          </Tag>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, namedModel) => {
        return (
          <Space>

            <Typography.Link ellipsis onClick={() => onDetailsClick(namedModel)}>Details</Typography.Link>

            <Typography.Link ellipsis onClick={() => onHistoryClick(namedModel)}>History</Typography.Link>

            <Typography.Link ellipsis onClick={() => editNamedModel(namedModel)}>Edit</Typography.Link>

          </Space>
        );
      },
    },
  ];

  return { columns };
};

export default useColumns;
